export const api = {
  universal: 'https://recept.gasztrojarat.hu/api/',
  upload: 'https://dev.aszakkor.hu/MediaAssets/api/'
}